import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import TopView from '@/views/TopView.vue'
import { useUserStore, useAlertStore } from '@/stores'
import projectsRoutes from './projects.routes'
import invoicesRoutes from './invoices.routes'
import customersRoutes from './customers.routes'
import postechsRoutes from './postechs.routes'
import ratesRoutes from './rates.routes'
import mapRoutes from './map.routes'
import { storeToRefs } from 'pinia'
//import { useAlertStore } from '@/stores/alert.store';
import NotFound from '@/views/NotFound.vue'

//const isAuthenticated = false;

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/:pathMatch(.*)', component: NotFound },
    {
      path: '/',
      name: 'top',
      component: TopView,
      children : [
        { path: '', redirect: { name: 'home' } },
        {
          path: 'home',
          name: 'home',
          component: HomeView,
        },
        { ...customersRoutes },
        { ...invoicesRoutes },
        { ...projectsRoutes },
        { ...postechsRoutes },
        { ...mapRoutes },
        { ...ratesRoutes }
      ]
    },

    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/restricted',
      name: 'restricted',
      component: () => import('../views/Restricted.vue')
    },
  ]
})

//check if user is authenticated
router.beforeEach((to, from) => {
  console.log('router.beforeEach...')
  // clear alert on route change
  const alertStore = useAlertStore()
  alertStore.clear()

  const userStore = useUserStore() //have to put this here to avoid race conditions in loading pinia / router
  const { currentGroup } = storeToRefs(userStore)
 // console.log('... authenticated ? : ' + userStore.isAuthenticated())
  if (
    // make sure the user is authenticated
    // !isAuthenticated &&
    !userStore.isAuthenticated() &&
    // ❗️ Avoid an infinite redirect
    to.name !== 'login'
  ) {
    // redirect the user to the login page
    return { name: 'login' }
  } else {
    //  return true;
    // }
   // console.log('..checking if meta authRequired..' + to.meta.authRequired)
    if (to.meta.authRequired === 'true') {
     // console.log('..., yes auth is required for this route')
    //  console.log('...currentGroup = ' + currentGroup.value)
      const groups: Array<String> = to.meta.groups
      if (groups.includes(currentGroup.value)) {
        return true
      } else {
        return { name: 'restricted' }
      }
      /*
      if (currentGroup.value === 'limited' || currentGroup.value === 'testing') {
        return { name: 'restricted' }
      } else{
        return true;
      }*/
    } else {
      return true
    }
  }
})

export default router
